(function(){
    'use strict';

    var $smpHeader = $('.smp-header'),
        $smpLower = $smpHeader.find('.smp-header__lower'),
        $smpSearchBtn = $('.smp-js-smpsearch-btn'),
        $smpMobileBtn = $('.smp-js-smpmobile-btn');

        if($smpHeader.length){

            $smpMobileBtn.click(function(){
                console.log('Lowermnu : ',$smpLower);
                console.log('Searchbtn: ',$smpSearchBtn);
                console.log('Clickedbtn: ',$smpMobileBtn);

                var $cur = $(this);
                var btnToggle = squiz.fn.smpToggleBtn($cur);

                $smpSearchBtn.removeClass('active');

                if(!btnToggle) {

                    $smpLower.addClass('open');

                } else {

                    $smpLower.removeClass('open');
                }

                return false;
            });

        }

}());
